import { render, staticRenderFns } from "./flowShop.vue?vue&type=template&id=4e04ab89&scoped=true"
import script from "./flowShop.vue?vue&type=script&lang=js"
export * from "./flowShop.vue?vue&type=script&lang=js"
import style0 from "./flowShop.vue?vue&type=style&index=0&id=4e04ab89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04ab89",
  null
  
)

export default component.exports